"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Status = require("../elements/Status");

var _Status2 = _interopRequireDefault(_Status);

var _Data = require("../../helpers/Data");

var _Monetario = require("../../helpers/Monetario");

require("../../assets/css/components/table/TableColumn.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = function (_React$Component) {
    _inherits(TableColumn, _React$Component);

    function TableColumn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableColumn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call.apply(_ref, [this].concat(args))), _this), _this.getContent = function () {
            var conteudo = _this.props.content;

            conteudo = _this.props.date ? _this.getData(_this.props.content) : conteudo;
            conteudo = _this.props.datetime ? _this.getDatetime(_this.props.content) : conteudo;

            conteudo = _this.getLimit(conteudo);
            conteudo = _this.props.upperCase ? _this.getUpperCase() : conteudo;
            conteudo = _this.props.lowerCase ? _this.getLowerCase() : conteudo;
            conteudo = _this.props.regex ? _this.getRegex(_this.props.pattern, _this.props.patternValue) : conteudo;
            conteudo = _this.props.monetario ? 'R$ ' + _this.getMonetario(_this.props.content) : conteudo;

            conteudo = _this.props.status ? _this.props.possibleStatus ? _react2.default.createElement(_Status2.default, { content: _this.props.content, possibleStatus: _this.props.possibleStatus, tooltip: _this.props.tooltip || false }) : _react2.default.createElement(_Status2.default, { status: _this.props.content, tooltip: _this.props.tooltip || false }) : conteudo;

            return conteudo ? conteudo : _this.props.children;
        }, _this.getActionColumn = function () {
            return _this.props.action ? _react2.default.createElement(
                "div",
                { className: "flat-table-options action flat-buttons" },
                _this.props.children
            ) : _this.props.children;
        }, _this.getData = function (date) {
            return (0, _Data.formatLongToDate)(date);
        }, _this.getDatetime = function (date) {
            return (0, _Data.formatLongToDateAndHour)(date);
        }, _this.getMonetario = function (valor) {
            return (0, _Monetario.formatarValorMonetario)(valor);

            // valor = valor.toString().replace(/\D/g, "");
            // valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
            // valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
            // valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");

            // return valor;
        }, _this.getLimit = function (conteudo) {
            return _this.props.limit && _this.props.limit < conteudo.length ? conteudo.substr(0, _this.props.limit) + " ..." : conteudo;
        }, _this.getLowerCase = function () {
            return typeof _this.props.content === 'string' ? _this.props.content.toLowerCase() : _this.props.content;
        }, _this.getUpperCase = function () {
            return typeof _this.props.content === 'string' ? _this.props.content.toUpperCase() : _this.props.content;
        }, _this.getRegex = function (pattern, value) {
            return _this.props.content.replace(pattern, value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableColumn, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "td",
                { scope: "row", headers: this.props.headers, className: 'c-width' + this.props.width },
                _react2.default.createElement(
                    "strong",
                    { className: "flat-table-header", "aria-hidden": "true" },
                    this.props.label || ""
                ),
                this.props.content === undefined ? this.getActionColumn() : this.getContent()
            );
        }
    }]);

    return TableColumn;
}(_react2.default.Component);

exports.default = TableColumn;


TableColumn.PropTypes = {
    width: _propTypes2.default.string,
    headers: _propTypes2.default.string,
    content: _propTypes2.default.string,
    label: _propTypes2.default.string,
    upperCase: _propTypes2.default.bool,
    action: _propTypes2.default.bool,
    date: _propTypes2.default.bool,
    status: _propTypes2.default.bool,
    tooltip: _propTypes2.default.bool,
    possibleStatus: _propTypes2.default.array,
    abbr: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/table/TableColumn.js
// module id = 1144
// module chunks = 0